import { Coverage, Household } from '@sky-distribution/adapter-core-pc-rest-interfaces';

const getHouseholdCoverages = (): Coverage[] => [
  {
    codeIdentifier: 'HOHCivilPersonalLiability',
    selected: true,
    terms: [
      {
        chosenTermValue: 'CPLSumInsuredBasicpln',
        patternCode: 'HOHCivilPersonalLiabilityCPLSumInsured',
        chosenTerm:
          'HOHCivilPersonalLiabilityCPLSumInsuredCPLSumInsuredBasicpln',
        coveragePublicID: 'HOHCivilPersonalLiability',
        defaultTerm_SKY: 'CPLSumInsuredBasicpln',
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [
          {
            code: 'CPLSumInsuredBasicpln',
            maxValue: 5,
            name: '100 000',
            optionValue: 3,
          },
          {
            code: 'CPLSumInsuredExtendedpln',
            maxValue: 5,
            name: '200 000',
            optionValue: 5,
          },
        ],
        publicID: 'HOHCivilPersonalLiabilityCPLSumInsured',
        required: true,
        type: 'OptionHOHCivilPersonalLiabilityCPLSumInsuredType',
      },
    ],
    description: 'CivilPersonalLiability',
    hasTerms: true,
    name: 'Civil Personal Liability',
    required: false,
    amount: {
      amount: 25,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHHomeAssistance',
    terms: [
      {
        chosenTermValue: 'Basic',
        patternCode: 'HASumInsured',
        chosenTerm: 'Basic',
        coveragePublicID: 'HOHHomeAssistance',
        defaultTerm_SKY: 'Basic',
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [
          {
            code: 'Basic',
            maxValue: 5,
            name: 'Basic',
            optionValue: 3,
          },
          {
            code: 'Extended',
            maxValue: 5,
            name: 'Extended',
            optionValue: 5,
          },
        ],
        publicID: 'HOHHomeAssistanceHomeAssistanceType',
        required: true,
        type: 'TypekeyHASumInsuredType',
      },
    ],
    description: 'Home Assistance',
    hasTerms: true,
    name: 'Home Assistance',
    required: false,
    selected: true,
    amount: {
      amount: 10,
      currency: 'pln',
    },
  },
];

const getDwellingCoverages = (): Coverage[] => [
  {
    codeIdentifier: 'HOHGlass',
    selected: true,
    terms: [
      {
        chosenTermValue: 'GlassSumInsuredBasicpln',
        patternCode: 'HOHGlassGlassSumInsured',
        chosenTerm: 'HOHGlassGlassSumInsuredGlassSumInsuredBasicpln',
        coveragePublicID: 'HOHGlass',
        defaultTerm_SKY: 'GlassSumInsuredBasicpln',
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [
          {
            code: 'GlassSumInsuredBasicpln',
            maxValue: 5,
            name: '3 000',
            optionValue: 3,
          },
          {
            code: 'GlassSumInsuredExtendedpln',
            maxValue: 5,
            name: '5 000',
            optionValue: 5,
          },
        ],
        publicID: 'HOHGlassGlassSumInsured',
        required: true,
        type: 'OptionHOHGlassGlassSumInsuredType',
      },
    ],
    description: 'Glass',
    hasTerms: true,
    name: 'Glass',
    required: false,
    amount: {
      amount: 45,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHMovables',
    selected: true,
    terms: [
      {
        chosenTermValue: '100000.00',
        patternCode: 'HOHMovablesSumInsured',
        chosenTerm: '100000.00',
        coveragePublicID: 'HOHMovables',
        directValue: 100000,
        directValueMax: 500000,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHMovablesSumInsured',
        required: true,
        type: 'DirectHOHMovablesSumInsuredType',
        valueType: 'Money',
      },
    ],
    description: '',
    hasTerms: true,
    name: 'Movables',
    required: false,
    amount: {
      amount: 53.63,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHMovablesFlood',
    selected: true,
    terms: [
      {
        chosenTermValue: '100000.00',
        patternCode: 'HOHMovablesFloodMovablesFloodSumInsured',
        chosenTerm: '100000.00',
        coveragePublicID: 'HOHMovablesFlood',
        directValue: 100000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHMovablesFloodMovablesFloodSumInsured',
        required: true,
        type: 'DirectHOHMovablesFloodMovablesFloodSumInsuredType',
        valueType: 'Money',
      },
    ],
    description: 'Flood damage - Movables',
    hasTerms: true,
    name: 'Flood damage - Movables',
    required: false,
    amount: {
      amount: 1.17,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHMovablesOvervoltage',
    selected: true,
    terms: [
      {
        chosenTermValue: '100000.00',
        patternCode: 'HOHMovablesOvervoltageMovablesOvervoltageSumInsured',
        chosenTerm: '100000.00',
        coveragePublicID: 'HOHMovablesOvervoltage',
        directValue: 100000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHMovablesOvervoltageMovablesOvervoltageSumInsured',
        required: true,
        type: 'DirectHOHMovablesOvervoltageMovablesOvervoltageSumInsuredType',
        valueType: 'Money',
      },
    ],
    description: 'Overvoltage - Movables',
    hasTerms: true,
    name: 'Overvoltage - Movables',
    required: false,
    amount: {
      amount: 4,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHMovablesTheft',
    selected: true,
    terms: [
      {
        chosenTermValue: '100000.00',
        patternCode: 'HOHMovablesTheftMovablesTheftSumInsured',
        chosenTerm: '100000.00',
        coveragePublicID: 'HOHMovablesTheft',
        directValue: 100000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHMovablesTheftMovablesTheftSumInsured',
        required: true,
        type: 'DirectHOHMovablesTheftMovablesTheftSumInsuredType',
        valueType: 'Money',
      },
    ],
    description: 'Theft - Movables',
    hasTerms: true,
    name: 'Theft - Movables',
    required: false,
    amount: {
      amount: 35.5,
      currency: 'pln',
    },
  },
  {
    codeIdentifier: 'HOHWalls',
    selected: true,
    terms: [
      {
        chosenTermValue: '1000000.00',
        patternCode: 'HOHWallsSumInsured',
        chosenTerm: '1000000.00',
        coveragePublicID: 'HOHWalls',
        directValue: 1000000,
        directValueMax: 2000000,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHWallsSumInsured',
        required: true,
        type: 'DirectHOHWallsSumInsuredType',
        valueType: 'Money',
      },
    ],
    amount: {
      amount: 453.03,
      currency: 'pln',
    },
    description: '',
    hasTerms: true,
    name: 'Walls&Immovables',
    required: true,
  },
  {
    codeIdentifier: 'HOHWallsFlood',
    selected: true,
    terms: [
      {
        chosenTermValue: '1000000.00',
        patternCode: 'HOHWallsFloodWallsFloodSumInsured',
        chosenTerm: '1000000.00',
        coveragePublicID: 'HOHWallsFlood',
        directValue: 1000000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHWallsFloodWallsFloodSumInsured',
        required: true,
        type: 'DirectHOHWallsFloodWallsFloodSumInsuredType',
        valueType: 'Money',
      },
    ],
    amount: {
      amount: 26.01,
      currency: 'pln',
    },
    description: 'Flood damage - Walls&Immovables',
    hasTerms: true,
    name: 'Flood damage - Walls&Immovables',
    required: false,
  },
  {
    codeIdentifier: 'HOHWallsOvervoltage',
    selected: true,
    terms: [
      {
        chosenTermValue: '1000000.00',
        patternCode: 'HOHWallsOvervoltageWallsOvervoltageSumInsured',
        chosenTerm: '1000000.00',
        coveragePublicID: 'HOHWallsOvervoltage',
        directValue: 1000000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHWallsOvervoltageWallsOvervoltageSumInsured',
        required: true,
        type: 'DirectHOHWallsOvervoltageWallsOvervoltageSumInsuredType',
        valueType: 'Money',
      },
    ],
    amount: {
      amount: 2,
      currency: 'pln',
    },
    description: 'OvervoltageWallsAndImmovables',
    hasTerms: true,
    name: 'Overvoltage - Walls&Immovables',
    required: false,
  },
  {
    codeIdentifier: 'HOHWallsTheft',
    terms: [
      {
        chosenTermValue: '100000.00',
        patternCode: 'HOHWallsTheftWallsTheftSumInsured',
        chosenTerm: '100000.00',
        coveragePublicID: 'HOHWallsTheft',
        directValue: 100000,
        directValueMax: 0,
        directValueMin: 0,
        isAscendingBetter: true,
        name: 'Sum insured',
        options: [],
        publicID: 'HOHWallsTheftWallsTheftSumInsured',
        required: true,
        type: 'DirectHOHWallsTheftWallsTheftSumInsuredType',
        valueType: 'Money',
      },
    ],
    description: 'TheftWalls',
    hasTerms: true,
    name: 'Theft - Walls&Immovables',
    required: false,
    selected: true,
    amount: {
      amount: 10,
      currency: 'pln',
    },
  },
];

export const getStaticVariants = (): Household[] => [
  {
    coverages: getHouseholdCoverages(),
    dwelling: {
      buildYear: 1999,
      dwellingType: 'House',
      movablesValue: '100000',
      propertyValue: '1000000',
      squareFootage: '123.12',
      dwellingAddress: {
        addressLine1: 'al. Jerozolimskie',
        addressLine2: '155',
        addressLine3: '13',
        addressType: 'home',
        city: 'Warszawa',
        country: 'PL',
        postalCode: '01-123',
      },
      dwellingCoverages: getDwellingCoverages(),
    },
  },
];
